// Reasons in the order the dialog offers them: stock in, stock out, then adjustment.
export const STOCK_REASONS = ['received', 'returned', 'dispensed', 'expired', 'damaged', 'adjustment'];

// Which way a reason moves stock: +1 in, -1 out, 0 either way (the user picks).
// The server refuses a booking against its reason's direction.
export const REASON_DIRECTION = {
  received: 1,
  returned: 1,
  dispensed: -1,
  expired: -1,
  damaged: -1,
  adjustment: 0,
};

export const EMPTY_TRANSACTION_FORM = {
  quantity: '',
  reason: '',
  notes: '',
};
